// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"32570dae","427":"e8186e6a","802":"ac77dbff"}[chunkId] + ".chunk.js";
};